var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransactionsView',{attrs:{"types":_vm.types,"controller":_vm.controller},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('topup.credit_transactions'))+" ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }